import { Area, AreaChart, ReferenceLine, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";
import { usd } from "@/components/dash/utils";

export const ProfitChart = ({ account: a }) => {
  if (!a) return null;
  const data = a.equity_curve.map((p, i) => ({ ...p, i }));
  const up = data[data.length - 1].value >= a.start_balance;
  const color = up ? "#34D399" : "#F87171";
  return (
    <section className="card p-5 sm:p-6 fade-up" data-testid="profit-chart">
      <h2 className="font-head font-bold text-lg">Practice balance over time</h2>
      <p className="text-xs text-slate-400 mt-1">Each point is a finished bet. Above the yellow line = in profit, below = losing.</p>
      {data.length < 2 ? (
        <p className="text-sm text-slate-500 py-8 text-center" data-testid="profit-chart-empty">The chart starts after the bot's first finished bet.</p>
      ) : (
        <div className="h-52 mt-4">
          <ResponsiveContainer width="100%" height="100%" minWidth={0} minHeight={100}>
            <AreaChart data={data} margin={{ top: 5, right: 5, left: 0, bottom: 0 }}>
              <defs>
                <linearGradient id="eq" x1="0" y1="0" x2="0" y2="1">
                  <stop offset="0%" stopColor={color} stopOpacity={0.3} /><stop offset="100%" stopColor={color} stopOpacity={0} />
                </linearGradient>
              </defs>
              <XAxis dataKey="i" stroke="#475569" fontSize={10} tickFormatter={(v) => (v ? `#${v}` : "start")} />
              <YAxis stroke="#475569" fontSize={10} width={60} domain={["auto", "auto"]} tickFormatter={(v) => `$${Math.round(v)}`} />
              <Tooltip contentStyle={{ background: "#0B1220", border: "1px solid #1A2338", fontSize: 12 }}
                labelFormatter={(i) => (i ? `Bet #${i}` : "Start")}
                formatter={(v, n, p) => [`${usd(v)}${p.payload.pnl ? ` (${p.payload.pnl > 0 ? "+" : ""}${usd(p.payload.pnl)} ${p.payload.side || ""})` : ""}`, "Balance"]} />
              <ReferenceLine y={a.start_balance} stroke="#FBBF24" strokeDasharray="4 4" />
              <Area type="stepAfter" dataKey="value" stroke={color} fill="url(#eq)" strokeWidth={2} isAnimationActive={false}
                dot={(p) => <circle key={p.index} cx={p.cx} cy={p.cy} r={3} fill={p.payload.pnl > 0 ? "#34D399" : p.payload.pnl < 0 ? "#F87171" : "#64748B"} />} />
            </AreaChart>
          </ResponsiveContainer>
        </div>
      )}
    </section>
  );
};
